import * as React from 'react';
import './Button.scss';
import { PropsWithChildren } from 'react';

export interface IButtonOwnProps {
  disabled?: boolean;
  onClick?: any;
  type?: 'submit' | 'button' | 'reset';
  className?: string;
}

export default class Button extends React.Component<
  PropsWithChildren<IButtonOwnProps>,
  Record<string, never>
> {
  public render() {
    const { className, disabled, onClick, type, ...rest } = this.props;
    return (
      <button
        {...rest}
        className={`button ${disabled ? 'disabled' : ''} ${
          className ? className : ''
        }`}
        type={type ? type : 'button'}
        onClick={onClick}
      >
        {this.props.children}{' '}
        <span className="glyphicon glyphicon-menu-right arrow" />
      </button>
    );
  }
}
